import React from 'react';
import { Card, CardContent, Typography, Box, Chip, Divider } from '@mui/material';
import { Link } from 'react-router-dom'; // Import Link from React Router for navigation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faClock} from '@fortawesome/free-solid-svg-icons'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useThemeContext } from '../../styles/ThemeContext';

import * as CONSTANTS from "../../constants"

const WazarenCard = ({wazaren, lang}) => {

    const { darkMode,  } = useThemeContext();

    let creator_editor_name = "";
    if (wazaren.creator_name !== "") {
        creator_editor_name = wazaren.creator_name;
    }
    if (wazaren.editor_name !== "") {
        creator_editor_name = creator_editor_name + (creator_editor_name !== ""? " & ": "") + wazaren.editor_name;
    }

    return (
        <Card>
            {/* Make the whole card clickable */}
            <Link to={`/${lang}/wazarens/${wazaren.uid.toString()}/`} style={{ textDecoration: 'none'}}>
                <CardContent>
                    {/* Card content info */}
                    <Box ml={2} >
                        <Typography variant="h6" component="div" color="textPrimary" sx={{ fontWeight: 'bold' }}>
                            {wazaren.name}
                        </Typography>
                        <Box sx={{ m: 1 }} />
                        <Typography variant="body2" color="textSecondary">
                            <FontAwesomeIcon icon={faUser} />
                            {" "+creator_editor_name}
                        </Typography>
                        {/* <Box sx={{ m: 1 }} />
                        <Typography variant="body2" color="textSecondary">
                            <FontAwesomeIcon icon={faClock} />
                            {" "+wazaren.date_created}
                        </Typography> */}
                        <Box sx={{ m: 1 }} />
                        <Box minHeight={'1.75rem'}>
                            {wazaren.tags.map((tag) => (
                                <Chip
                                    key={tag.toString()} 
                                    label={CONSTANTS.WAZAREN_TAGS[tag][lang].toString()}
                                    size='small'
                                    variant="outlined"
                                    sx={{
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                        marginRight: '0.25rem',
                                        marginTop: '0.25rem',
                                    }}
                                />
                            ))}
                        </Box>
                        <Box sx={{ m: 1 }} />
                        <Divider />
                        <Box sx={{ m: 1 }} />
                        <Box display="flex" alignItems="center">
                            <VisibilityIcon style={{ color: darkMode? 'white': 'black' }}/>
                            <Typography ml={1}  variant="body1" color="textSecondary">{wazaren.views}</Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Link>
        </Card>
    );
};

export default WazarenCard;